import { render, staticRenderFns } from "./UICard.vue?vue&type=template&id=6407952f"
import script from "./UICard.vue?vue&type=script&lang=js"
export * from "./UICard.vue?vue&type=script&lang=js"
import style0 from "./UICard.vue?vue&type=style&index=0&id=6407952f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports